<h1 mat-dialog-title>
  {{
    data?.title || 'invitationTextDialog.title'
      | translate
        : {
            unit:
              (data.mode === 'live-event' ? 'liveEvent.name' : 'exam.name')
              | translate
          }
  }}
</h1>
@if (data.interactive) {
<h3 class="title-dropdown">{{ 'invitationTextDialog.to' | translate }} :</h3>
<div class="dropdown-container">
  <qa-form-field-select
    class="sendMail-type"
    [control]="sendTo"
    [options]="sendMailOptions"
    [compareFn]="compareFn"
  ></qa-form-field-select>
</div>
<h3 class="title-text">{{ 'invitationTextDialog.text' | translate }} :</h3>
}
<mat-dialog-content>
  @if (!blurInput) {
  <mat-form-field appearance="outline">
    <mat-label>
      {{ 'Text' }}
    </mat-label>
    <textarea (blur)="onBlur()" [value]="text" #textArea matInput rows="20">
    </textarea>
  </mat-form-field>
  } @else {
  <div class="label-view">
    <code
      class="invtext-render"
      (click)="onEdit()"
      [innerHTML]="parseText(text)"
    ></code>
  </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="space-between-btn">
  <button color="primary" mat-button mat-dialog-close type="button">
    {{ 'common.button.shutdown' | translate }}
  </button>
  <div class="text-actions">
    <a
      (click)="copyWeblink()"
      class="mat-button mat-button-base mat-primary copy-link"
      color="primary"
      target="_blank"
    >
      <mat-icon>content_copy</mat-icon>
      {{ 'invitationTextDialog.copyInvitationText' | translate }}
    </a>
    <button
      mat-stroked-button
      color="primary"
      target="_blank"
      (click)="sendMail()"
    >
      <mat-icon>email</mat-icon>
      {{ 'invitationTextDialog.sendViaMail' | translate }}
    </button>
  </div>
</mat-dialog-actions>
